module.exports = __webpack_public_path__ + "assets/img/20-double-eleven_task-two.c531aa43.png";